import paymentInfoReducer from './payment_info';
import paymentButtonReducer from './payment_button';
import policyReducer from './policy';

export default {
  paymentInfo: paymentInfoReducer,
  paymentButton: paymentButtonReducer,
  policy: policyReducer,
};
